import { render, staticRenderFns } from "./SolicitacaoHistoricoGeral.vue?vue&type=template&id=f2af7d88&scoped=true"
import script from "./SolicitacaoHistoricoGeral.vue?vue&type=script&lang=js"
export * from "./SolicitacaoHistoricoGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af7d88",
  null
  
)

export default component.exports